import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { News } from '../../../news/models/news';

/**
 * Read-only popup for application (admin) news on the business dashboard.
 *
 * The content is rendered by a read-only Quill editor instead of [innerHTML]:
 * Quill 2 saves every space as &nbsp;, so bound HTML would never wrap, and
 * Angular's sanitizer strips the inline colours authors apply.
 */
@Component({
  selector: 'app-admin-news-viewer',
  templateUrl: './admin-news-viewer.component.html',
  styleUrls: ['./admin-news-viewer.component.scss'],
  standalone: false
})
export class AdminNewsViewerComponent implements OnChanges {
  /** News item to show. Setting an item opens the dialog. */
  @Input() news: News | null = null;
  /** Emitted once the dialog has closed, so the parent can clear its selection. */
  @Output() closed = new EventEmitter<void>();

  visible = false;

  ngOnChanges(changes: SimpleChanges): void {
    if ('news' in changes && this.news !== null) {
      this.visible = true;
    }
  }

  close(): void {
    this.visible = false;
  }
}
